import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { StatusConfig } from "@shared/models/status-config.model";

@Component({
  selector: "app-status-card",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./status-card.component.html",
})
export class StatusCardComponent implements OnInit {
  @Input() status!: string;
  @Input() statusConfig!: Record<string, StatusConfig>;
  @Input() date?: Date;
  translatedText!: string;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    const translationKey = this.statusConfig[this.status].text;
    const translationParams = this.date ? { date: this.date } : {};

    this.translate.get(translationKey, translationParams).subscribe((res: string) => {
      this.translatedText = res;
    });
  }
}
